var modOrderDetail = function(){
    var scope = ".js-mod-order-detail";
    ui.ready(
        scope,
        function($mod){
            var orderId = $mod.data("id");

            $mod.find(scope+"__follow-btn").click(
                function(ev){
                    ev.preventDefault();
                    window.open($(this).attr("href"));
                }
            );
            $mod.find(scope+"__order-again-btn").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\shopCartController::addOrderToCart",
                        [orderId],
                        function(resp){
                            if(resp.status=="ok"){
                                window.location = resp.url;
                            }else{
                                utils.alertEndpointResponse(resp);
                            }
                        }
                    )
                }
            );
            $mod.find(scope+"__print-btn").click(
                function(ev){
                    ev.preventDefault();
                    window.print();
                }
            );
            $mod.find(scope+"__invoice-btn").click(
                function(ev){
                    ev.preventDefault();
                    window.location = "?invoice=1";
                }
            );
            $mod.find(scope+"__logistic-status").click(
                function(ev){
                    ev.preventDefault();
                    $mod.find(scope+"__logistic-changes").toggle();
                }
            );
            $mod.find(scope+"__cancel-btn").click(
                function(ev){
                    ev.preventDefault();
                    gvf.endpoint(
                        "web\\orderDetailController::getTranslateCancelText",
                        [],
                        function (response) {
                            new swal({
                                title: response.title,
                                text: response.message,
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#fc4b6c",
                                confirmButtonText: "OK",
                                cancelButtonText: "No",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            }).then(
                                function(isConfirm){
                                    if(isConfirm.isConfirmed){
                                        gvf.endpoint(
                                            "web\\orderDetailController::cancelOrder",
                                            [orderId],
                                            function(resp){
                                                if(resp.status=="ok"){
                                                    window.location.reload();
                                                }else{
                                                    utils.alertEndpointResponse(resp);
                                                }
                                            }
                                        );
                                    }
                            });
                        }
                    )
                }
            );

        }
    );
}();